/**
 * View for selecting counterparty in the trade report form
 * view consists of a radio button group and a suggest input field
 * suggest input field  is shown based on selected counterparty type
 **/

// autocompletetradingparticipant
// autocompleteothersecuritydealer
import BaseView from '../../base-view';
import Suggest from '../suggest/index';
import Model from './model';

export default BaseView.extend({
	events: {
		'change input[type="radio"]': 'onCounterpartyChanged'
	},

	suggestUrls: {
		defaultUrl: '/extranet/autocompleteparticipant',
		bxtradingparticipant: '/extranet/autocompletetradingparticipant',
		othersecuritiesdealer: '/extranet/autocompleteothersecuritydealer'
	},

	initialize: function() {
		// create model
		this.model = new Model();

		// reference elements
		this.inputField = this.query('.js-counterparty');

		// create subview(s)
		this.suggestView = new Suggest.Views.Main({
			el: '.js-search-counterparty',
			dataUrl: this.suggestUrls.defaultUrl
		});

		// determine pre-checked value and toggle input field
		var checked = document.querySelector('input[name="CounterPartyType"]:checked');

		if (checked) {
			this.selectCounterparty(checked);
		}
	},

	/**
	 * Counterparty change handler
	 **/
	onCounterpartyChanged: function(e) {
		var radio = e.target;

		this.selectCounterparty(radio);
	},

	selectCounterparty: function(inputElement) {
		var counterpartyType = inputElement.value.toLowerCase();

		// show inputfield for radiobox
		this.toggleInputField(counterpartyType);

		// clear suggest field
		this.suggestView.clear();

		// update suggest data url
		this.updateSuggestUrl(counterpartyType);
	},

	/**
	 * Sow or hide the suggest view
	 * only hide when counterparty type is 'customer'
	 **/
	toggleInputField: function(counterpartyType) {

		this.inputField.classList.toggle('is-hidden', (counterpartyType.toLowerCase() === 'customer'));
	},

	updateSuggestUrl: function(counterpartyType) {
		var url = this.suggestUrls[counterpartyType] ||  this.suggestUrls.defaultUrl;
		this.suggestView.setDataUrl(url);
	},

	render: function() {
		// render subview
		this.suggestView.render();

		return this;
	}
});
